// REACT & REDUX
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Route, Switch, withRouter } from "react-router-dom";

// STYLE, PROPS & TRANSLATIONS
import "careconnect-ui/lib/css/global.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "react-table/react-table.css";
import "@fortawesome/fontawesome-free";

// COMMON

// COMPONENTS

// CONTAINERS
import Root from "./components/root/Root.container";
import VersionStamp from "./components/common/VersionStamp";
import Login from "./components/login/Login.container";
import Home from "./components/home/Home.container";

// ACTIONS & API

// *************************************************************************************************************************************

//const RedirectToHome = () => <Redirect to="/" />;

class App extends Component {
    renderLogin = () => {
        return (
            <div>
                <div>
                    <main>
                        <Login />
                    </main>
                </div>
            </div>
        );
    };

    renderMain = () => {
        return (
            <Fragment>
                <Switch>
                    <Root>
                        <Route exact path={""} component={Home} />
                    </Root>
                </Switch>
            </Fragment>
        );
    };

    render() {
        return (
            <Fragment>
                {this.renderMain()}
                <VersionStamp />
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({});

export default withRouter(connect(mapStateToProps, null)(App));
